// Remembers, on the guest's own phone, which room they unlocked with the PIN
// so they can come back to its domotica without re-typing it.
// The PIN is re-validated server-side on every visit: once the stay ends and
// the TTLock code expires, the saved session is silently dropped.
const KEY = "pozzo_room_session";
const TTL_MS = 14 * 24 * 60 * 60 * 1000;

export function getRoomSession() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (!s?.slug || !s?.pin || Date.now() - (s.ts || 0) > TTL_MS) { localStorage.removeItem(KEY); return null; }
    return s;
  } catch { return null; }
}

export function saveRoomSession({ slug, pin, name, guest = "" }) {
  try { localStorage.setItem(KEY, JSON.stringify({ slug, pin, name, guest, ts: Date.now(), checked: Date.now() })); } catch { /* ignore */ }
  window.dispatchEvent(new Event("room-session-change"));
}

// Marks the saved PIN as freshly re-validated by the server (no event: nothing visible changes).
export function touchRoomSession() {
  const s = getRoomSession();
  if (!s) return;
  try { localStorage.setItem(KEY, JSON.stringify({ ...s, checked: Date.now() })); } catch { /* ignore */ }
}

export function clearRoomSession() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
  window.dispatchEvent(new Event("room-session-change"));
}
